import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '<'
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.General settings' | translate }}</h1>
        </div>
         <div class="person01">
            <form role="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <div class="form nomargin">
                        <form-row error="vm.form.errors.maxSkillLevel">
                            <label class="label">{{ 'user.Maximum skill level' | translate }} *</label>
                            <div class="items">
                                <div class="items">
                                    <input ng-model="vm.form.model.maxSkillLevel" type="text" class="form-control">
                                </div>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.defaultSkillLevel">
                            <label class="label">{{ 'user.Default skill level' | translate }} *</label>
                            <div class="items">
                                <div class="items">
                                    <input ng-model="vm.form.model.defaultSkillLevel" type="text" class="form-control">
                                </div>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </div>
                    <ul class="actions01">
                        <li class="primary">
                            <input type="submit" class="btn main" value="{{ 'general.Save' | translate }}">
                        </li>
                    </ul>
                </form-wrapper>
            </form>
        </div>
`
})
export default class {
    constructor (FormFactory) {
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.company);
    }

    save () {
        this.form.save().then(() => {
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/settings/index.js